<div class="deposit-body" [ngClass]="isDesktop ? 'desktop': 'mobile'" fxLayout="column" fxLayoutAlign="start center">
    <ng-container *ngIf="!selectPayment else selectpayment">
        <ng-container *ngIf="!selectBonusTriggered else selectbonus">
            <div *ngIf="paymentList === undefined || paymentList?.length>0 else nopayment" class="deposit-form-wrapper">
                <div id="deposit-form" class="desktop-panel" *ngIf="!isExtendedPaymentFlow else extendedPayment" [ngClass]="isDesktop ? 'desktop': 'mobile'">
                    <div class="pending-withdrawal" [class.pw-list-isOpen]="isOpen" *ngIf="pendingList?.results.length > 0" #pendingWithdrawal (click)="toggleOpen($event)">
                        <div class="pending-collapse">
                            <div>
                                <span class="left-wd" i18n>{{ pendingList?.count }}</span>
                                <div>
                                    <h1 i18n>Pending Withdrawals</h1>
                                    <p i18n>Cancel to return to play immediately.</p>
                                </div>
                            </div>
                            <img src="{{licenceService.getKey('arrow-icon')}}" alt="arrow-right" [class.isopen]="isOpen" />
                        </div>
                        <div *ngIf="isOpen" #pendingWithdrawalValue>
                            <div class="loop" *ngFor="let item of pendingList?.results;let last = last" [@disappear]="item.state || 'in'">
                                <div class="entry" (click)="checkConfirmCancel(item)" fxLayout="row" fxLayoutAlign="center center">
                                    <div class="item" fxLayoutAlign="start center">
                                        <div class="name-group">
                                            <div class="type">
                                                <div class="data">
                                                    {{ item.date | slice:0:10 }}
                                                </div>
                                                <div class="h16-22">
                                                    {{ item.operator.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item-tail" fxLayoutAlign="start center">
                                        <div class="tail-group">
                                            <div class="amount h16-22">
                                                {{ item.transaction_value }} {{ item.transaction_currency }}
                                            </div>
                                            <div class="h12" *ngIf="isDesktop">
                                                <button round-button size="small" filled="filled" color="orange" class="cancel-btn" i18n>
                                                    cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="h12" *ngIf="!isDesktop">
                                    <button round-button size="small" (click)="checkConfirmCancel(item)" filled="filled" color="orange" class="cancel-btn" i18n>cancel
                                    </button>
                                </div>
                                <!-- <div *ngIf="!last" class="divider">
                                    <mat-divider></mat-divider>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="bonus-selector">
                        <div *ngIf="isDesktop" class="select-bonus-text">1. <span i18n>Select bonus offer</span>:</div>
                        <div class="deposit-bonus-selector" fxLayoutAlign="center center">
                            <app-deposit-bonus-selector [bonusList]="bonusList" [selectedBonus]="selectedBonus" [isReady]="isBonusesReady" (click)="isBonusesReady && selectBonusTriggered=true" (selectedTeaser)="selectTeaserValue($event)">
                            </app-deposit-bonus-selector>
                        </div>
                    </div>
                    <form *ngIf="depositForm" class="form-custom-design" [formGroup]="depositForm" (ngSubmit)="onSubmit(depositForm)">
                        <div class="enter-amount-text">2. <span i18n>Choose payment options</span>:</div>
                        <div class="price-value-carousel" fxLayoutAlign="center center" *ngIf="defaultPrices">
                            <app-price-value-carousel [currentValue]="currentAmount" [priceValues]="defaultPrices" [currency]="currency" (selectedPrice)="selectPriceValue($event)">
                            </app-price-value-carousel>
                        </div>

                        <div [fxLayout]="isDesktop? 'row' : 'column' " fxLayoutGap='16px'>
                            <div style="width:100%;">
                                <div class="deposit-amount-form-field">
                                    <mat-form-field class="mat-headline deposit-value" appearance="outline">
                                        <!-- <mat-label i18n>Enter Amount</mat-label> -->
                                        <input matInput color="primary" (input)="amountChange($event.target.value)" type="tel" formControlName="amount">
                                        <span class="currency">{{ currency }}</span>
                                    </mat-form-field>
                                    <mat-error i18n *ngIf="
                                  depositForm.get('amount').hasError('required')
                              ">Please provide the value.
                                    </mat-error>
                                    <mat-error i18n *ngIf="
                                  !depositForm.get('amount').hasError('required') &&
                                  depositForm.get('amount').hasError('valueTooBig')
                              ">The value exceeds maximum for this item.
                                    </mat-error>
                                    <mat-error i18n *ngIf="
                                  !depositForm.get('amount').hasError('required') &&
                                  depositForm.get('amount').hasError('valueTooSmall')
                              ">The value is too low for this item.
                                    </mat-error>
                                    <mat-error *ngIf="depositForm.get('amount')?.errors?.serverError">
                                        {{ depositForm.get('amount').errors?.serverError }}
                                    </mat-error>
                                </div>
                            </div>

                            <div style="width:100%">
                                <div fxLayoutAlign="center center" class="payment-method-selector-wrapper">
                                    <app-payment-method-selector (click)="selectPaymentClick()" [selectedPayment]="selectedPaymentMethod">
                                    </app-payment-method-selector>
                                </div>

                            </div>
                        </div>
                        <div class="limits">*Min: {{ minPrice }} {{ currency | uppercase }}, Max: {{ maxPrice }} {{
                            currency |
                            uppercase
                            }},&nbsp;<span i18n>Fee</span>: 0 {{ currency | uppercase }}
                        </div>

                        <ng-container *ngIf="!transactionCustomUIFinished else customuifinshed"></ng-container>

                        <div *ngIf="isFullDataDepositAllowed && additionalField?.length > 0" class="additional-form-fields" fxLayout="column" fxLayoutGap="18px" fxLayoutAlign="start center">
                            <ng-container [ngSwitch]="item.type" *ngFor="let item of additionalField">
                                <mat-checkbox *ngSwitchCase="'checkbox'" color="primary" [formControlName]="item.name" checked>{{ item.label }}
                                </mat-checkbox>
                                <input *ngSwitchCase="'hidden'" type="hidden" [formControlName]="item.name" [value]="item.value" />
                                <mat-form-field *ngSwitchCase="'select'" appearance="outline" style="min-width: 285px;">
                                    <mat-label>{{ item.label }}</mat-label>
                                    <mat-select panelClass="payment-overlay" [formControlName]="item.name">
                                        <mat-select-trigger class="selected-container">
                                            <span i18n>{{ cryptoSelectedValue }}</span>
                                            <img src="assets/icons/icon-arrow-down.svg" alt="icon-arrow-down">
                                        </mat-select-trigger>
                                        <ng-container *ngIf="item.choices && item.choices.length > 0">
                                            <mat-option *ngFor="let elem of item.choices" [value]="elem.value" (click)="clickable(elem.display_name)">{{ elem.display_name }}
                                            </mat-option>
                                            <mat-option value="" i18n>add new account</mat-option>
                                        </ng-container>
                                        <ng-container *ngIf="item.selections && item.selections.length > 0">
                                            <mat-option *ngFor="let elem of item.selections;" [value]="elem.value" (click)="clickable(elem.name)">
                                                <span>{{ elem.name }}</span>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                    <!-- <select [formControlName]="item.name" matNativeControl>
                                        <ng-container *ngIf="item.choices && item.choices.length > 0">
                                            <option *ngFor="let elem of item.choices" [value]="elem.value" selected>{{elem.display_name}}</option>
                                            <option value="" i18n>add new account</option>
                                        </ng-container>
                                        <ng-container *ngIf="item.selections && item.selections.length > 0">
                                            <option *ngFor="let elem of item.selections; let first = first" [value]="elem.value" [selected]="first">{{elem.name}}</option>
                                        </ng-container>

                                    </select> -->
                                </mat-form-field>
                                <mat-form-field *ngSwitchCase="'input'" appearance="outline" style="min-width: 285px;">
                                    <mat-label>{{ item.label }}</mat-label>
                                    <input matInput [formControlName]="item.name" style="margin-top: -10px" />
                                    <mat-error i18n *ngIf="depositForm?.get(item.name)?.hasError('required')
                                                        "class="email-error">Please provide the value.
                                    </mat-error>
                                    <mat-error i18n *ngIf="depositForm?.get(item.name)?.hasError('email')
                                    "class="email-error">Enter a valid email address.
                                    </mat-error>
                                </mat-form-field>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="isFullDataDepositAllowed && selectedPaymentMethod?.paymentMethodProvider === paymentIQMethodProvider && showPaymentiq">
                            <ng-container #paymentiq>
                                <div *ngIf="isShowPaymentIqModulePlaceholder">
                                    <div style="height: 128px"></div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="selectedPaymentMethod?.addPraxisHpf">
                            <app-praxis-hpf #praxishpf></app-praxis-hpf>
                        </ng-container>
                        <div class="custom-flow" #customuiflow></div>
                        <ng-container *ngIf="isFullDataDepositAllowed else noFullData">
                            <div [ngStyle]="showPaymentiq ? {'margin-top.px': isDesktop ? '0' : '-15'} : additionalField?.length ? {'margin-top.px': isDesktop ? hasAdditionalInput ? '0' : '-10' : hasAdditionalInput ? '-15' : '-25' } : null">
                                <div [ngClass]="isDesktop ? 'buttons-desktop' : 'buttons'" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="center center">
                                    <button *ngIf="!isDisplayPaymentLink && isDesktop" round-button size="medium" filled="filled" type="submit" color="accent" [disabled]="_formSubmitted || depositForm.invalid" [ngClass]="{'spinner': isLoading}"><span *ngIf="!isLoading" i18n>proceed to payment</span>
                                    </button>
                                    <button *ngIf="!isDisplayPaymentLink && !isDesktop" round-button size="large" filled="filled" type="submit" color="accent" [disabled]="_formSubmitted || depositForm.invalid" [ngClass]="{'spinner': isLoading}"><span *ngIf="!isLoading" i18n>proceed to payment</span>
                                    </button>
                                    <a #paymentlinkelement (click)="onPaymentLinkClick()" [href]="paymentLink" *ngIf="isDisplayPaymentLink" rel="noreferrer"><span class="payment-link"><span *ngIf="!isLoading" i18n>open payment url</span>&nbsp;<span *ngIf="!!timerValue && timerValue>0" style="text-transform: lowercase;">({{ timerValue }}s)</span></span></a>
                                </div>
                            </div>
                            <!-- <ng-container *ngIf="isFullDataDepositAllowed else noFullData">
                                <div [ngStyle]="showPaymentiq ? {'margin-top.px': isDesktop ? '0' : '-15'} : additionalField?.length ? {'margin-top.px': isDesktop ? hasAdditionalInput ? '0' : '-10' : hasAdditionalInput ? '-15' : '-25' } : null">
                                    <div [ngClass]="isDesktop ? 'buttons-desktop' : 'buttons'" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="center center">
                                        <ng-container *ngIf="!isCustomUIPaymentFlow">
                                            <button *ngIf="!isDisplayPaymentLink && isDesktop" round-button size="medium" filled="filled" type="submit" color="accent" [ngClass]="{'spinner': isLoading}"><span style="color: #2a3150;" *ngIf="!isLoading" i18n>proceed to payment</span></button>
                                            <button *ngIf="!isDisplayPaymentLink && !isDesktop" round-button size="large" filled="filled" type="submit" color="accent" [ngClass]="{'spinner': isLoading}"><span style="color: #2a3150;" *ngIf="!isLoading" i18n>proceed to payment</span></button>
                                            <a #paymentlinkelement (click)="onPaymentLinkClick()" [href]="paymentLink" *ngIf="isDisplayPaymentLink" rel="noreferrer"><span class="payment-link"><span *ngIf="!isLoading" i18n>open payment url</span>&nbsp;<span *ngIf="!!timerValue && timerValue>0" style="text-transform: lowercase;">({{timerValue}}s)</span></span></a>
                                        </ng-container>
                                        <ng-container *ngIf="isCustomUIPaymentFlow">
                                            <button *ngIf="isDesktop" round-button size="medium" filled="filled" type="submit" color="accent" [ngClass]="{'spinner': isLoading}"><span style="color: #2a3150;" *ngIf="!isLoading" i18n>submit</span></button>
                                            <button *ngIf="!isDesktop" round-button size="large" filled="filled" type="submit" color="accent" [ngClass]="{'spinner': isLoading}"><span style="color: #2a3150;" *ngIf="!isLoading" i18n>submit</span></button>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container> -->
                            <input type="hidden" formControlName="payment_id" />
                            <input type="hidden" formControlName="bonus_id" />
                            <input type="hidden" formControlName="code_id" />
                            <input type="hidden" formControlName="freespin_code" />
                        </ng-container>
                    </form>
                    <ng-container *ngIf="isClosable">
                        <div [ngClass]="isDesktop ? 'buttons-desktop' : 'buttons'" fxLayoutAlign="center center">
                            <button mat-stroked-button color="primary" [routerLink]="['']" i18n>close</button>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="descritpion && isFullDataDepositAllowed" class="description-box" fxLayout="row" fxLayoutAlign="start center" [fxLayoutGap]="isDesktop ? '16px' : '20px'">
                    <img src="assets/icons/icon-payment-info.svg" alt="payment-info" />
                    <div class="descirption" [innerHTML]="descritpion"></div>
                </div>
            </div>

            <ng-template #nopayment>
                <div class="no-payment">
                    <span i18n>Sorry, there are no payment methods available for your country.</span>
                </div>
            </ng-template>
        </ng-container>
    </ng-container>
</div>
<app-user-notifications></app-user-notifications>

<ng-template #noFullData>
    <ng-container *ngIf="detectDeviceService.isDesktop() else noFullDataMobile">
        <div class="require-full-deposit-wrapper" fxLayout="column" fxLayoutAlign="center center">
            <div class="require-full-deposit-box" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                <img src="assets/icons/icon-payment-warning.svg" alt="payment-info" />
                <div class="require-full-deposit-info" i18n>Please note that we need some more of your billing
                    information in order to proceed with the payment method. Please add it to continue.
                </div>
                <div class="buttons-desktop" fxLayoutAlign="center center">
                    <button type="button" round-button size="small" filled="empty" *ngIf="detectDeviceService.isDesktop()" (click)="redirectProfile()" color="warn" i18n>Edit profile
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #noFullDataMobile>
        <div class="require-full-deposit-wrapper" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="6px">
            <div class="require-full-deposit-box" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                <img src="assets/icons/icon-payment-warning.svg" alt="payment-info" />
                <div class="require-full-deposit-info" i18n>Please note that we need some more of your billing
                    information to proceed with the payment method. Please add it to continue
                </div>
            </div>
            <div class="buttons" fxLayoutAlign="center center">
                <button type="button" round-button size="small" filled="empty" *ngIf="!detectDeviceService.isDesktop()" (click)="redirectProfile()" color="warn" i18n>Edit profile
                </button>
            </div>
        </div>
    </ng-template>
</ng-template>

<ng-template #selectpayment>
    <app-payment-method-sheet (paymentMethod)="selectPaymentMethod($event, true)" [selectedMethod]="selectedPaymentMethod" [paymentList]="paymentList" [selectedBonus]="selectedBonus"></app-payment-method-sheet>
</ng-template>
<ng-template #selectbonus>
    <app-bonus-selector-dialog [selectedBonusInfo]="selectedBonus" [bonusList]="bonusList" [selectedPaymentMethod]="selectedPaymentMethod" (selectedBonus)="selectBonus($event)"></app-bonus-selector-dialog>
</ng-template>
<ng-template #customuifinshed>
    <div class="finished">
        <h3 i18n>Thank you for submitting your transaction, we're checking it now and soon it should appear on your account.</h3>
        <div class="button">
            <button (click)="closeCustomUiFlow()" round-button size="medium" filled="filled" type="submit" color="accent"><span style="color: #2a3150;" *ngIf="!isLoading" i18n>Close</span></button>
        </div>
    </div>
</ng-template>
<ng-template #extendedPayment>
    <router-outlet></router-outlet>
</ng-template>